import {
  Component, ComponentFactory, OnDestroy
} from '@angular/core';
import {ConfirmMakeUserAdminComponent} from './confirm-make-user-admin/confirm-make-user-admin.component';
import {ConfirmDeactivateUserComponent} from './confirm-deactivate-user/confirm-deactivate-user.component';
import {ConfirmReactivateUserComponent} from './confirm-reactivate-user/confirm-reactivate-user.component';
import {ConfirmRemoveUserAdminComponent} from './confirm-remove-user-admin/confirm-remove-user-admin.component';
import { ModalFactoryComponent } from 'web-common/src/app/modals/modal-factory/modal-factory.component';
import { ModalBaseComponent } from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import {AdminAvailableModals} from './admin-available-modals';
import { ReportDownloadNotificationComponent } from './report-download-notification/report-download-notification.component';

@Component({
    selector: 'app-admin-modal-component',
    template: `
    <ng-template #dynamicComponentContainer></ng-template>
  `
})
export class AdminModalFactoryComponent extends ModalFactoryComponent<any> implements OnDestroy {

  resolveModalInstance(modalToCreate: AdminAvailableModals): ComponentFactory<ModalBaseComponent<any>> {
    if (modalToCreate === AdminAvailableModals.CONFIRM_DISABLE_USER) {
      return this.factoryFor(ConfirmDeactivateUserComponent);
    }
    if (modalToCreate === AdminAvailableModals.CONFIRM_MAKE_USER_ADMIN) {
      return this.factoryFor(ConfirmMakeUserAdminComponent);
    }
    if (modalToCreate === AdminAvailableModals.CONFIRM_ENABLE_USER) {
      return this.factoryFor(ConfirmReactivateUserComponent);
    }
    if (modalToCreate === AdminAvailableModals.CONFIRM_REMOVE_USER_ADMIN) {
      return  this.factoryFor(ConfirmRemoveUserAdminComponent);
    }
    if (modalToCreate === AdminAvailableModals.REPORT_DOWNLOAD_NOTIFICATION) {
      return this.factoryFor(ReportDownloadNotificationComponent)
    }
  }

}
